import { createSegmentActionsPlugin } from './actions';
var ampSRSegmentWrapper = function (options) {
    return createSegmentActionsPlugin(options);
};
export default ampSRSegmentWrapper;
//# sourceMappingURL=index.js.map